let showMore = true;
const infoContentMore = document.getElementById('infoContentMore');
const moreLessButton = document.getElementById('infoContentTrigger');

moreLessButton.addEventListener('click', function () {
    if (showMore) {
        showMore = false;
        infoContentMore.style.display = 'block';
        this.innerHTML = this.getAttribute("data-less");
        this.setAttribute('aria-expanded', "true");
        infoContentMore.focus();
    } else {
        showMore = true;
        infoContentMore.style.display = 'none';
        this.innerHTML = this.getAttribute("data-more");
        this.setAttribute('aria-expanded', "false");
    }
});